import {
  LPSettlementInstructionStatusEnum,
  SettlementInstructionDirectionEnum,
  type LPSettlementInstructionStatusEnum as LPSettlementInstructionStatus,
} from '@talos/kyoko';
import { getDetailedLPAssetStatus } from './lpAssetStatusMapping';

const RECOVERABLE_STATUSES: LPSettlementInstructionStatus[] = [
  LPSettlementInstructionStatusEnum.Pending,
  LPSettlementInstructionStatusEnum.Error,
];

export function canBookLPSettlementInstruction(status: LPSettlementInstructionStatus, hasEditRole: boolean): boolean {
  return hasEditRole && RECOVERABLE_STATUSES.includes(status);
}

export function getBatchDetailsActionLabel(
  status: LPSettlementInstructionStatus,
  direction: SettlementInstructionDirectionEnum,
  hasEditRole: boolean
): string {
  if (!canBookLPSettlementInstruction(status, hasEditRole)) {
    return 'View';
  }

  if (direction === SettlementInstructionDirectionEnum.Outbound) {
    return status === LPSettlementInstructionStatusEnum.Error ? 'Retry' : 'Initiate';
  }

  return 'Update';
}

export function getInstructionStatusDisplayText(
  status: LPSettlementInstructionStatus,
  direction: SettlementInstructionDirectionEnum,
  errorText?: string | null
): string {
  if (status === LPSettlementInstructionStatusEnum.Error && errorText) {
    return `Error: ${errorText}`;
  }

  const detailedStatus = getDetailedLPAssetStatus(status, direction);
  return detailedStatus ?? status;
}

export function getDirectionDisplayLabel(direction: SettlementInstructionDirectionEnum): string {
  switch (direction) {
    case SettlementInstructionDirectionEnum.Outbound:
      return 'Outgoing';
    case SettlementInstructionDirectionEnum.Inbound:
      return 'Incoming';
    default: {
      direction satisfies never;
      return '';
    }
  }
}

export function getOutboundTransferSubmitLabel(
  status: LPSettlementInstructionStatus,
  currentMethod: 'initiate' | 'manual'
): string {
  if (currentMethod === 'manual') {
    return 'Mark complete';
  }

  return status === LPSettlementInstructionStatusEnum.Error ? 'Retry Transfer' : 'Initiate Transfer';
}
